import { FC } from 'react'
// @ts-ignore
import { CwsCarousel } from 'cms-web-styleguide'
import { ImagePageBanner } from '@api/content'
import Link from 'next/link'
import { CldImage } from 'next-cloudinary'
import { useMediaLess } from '@ui/hooks/useMediaLess'

const BANNER_HEIGHT = 226

export interface BannersProps {
  banners: ImagePageBanner[]
}

export const Banners: FC<BannersProps> = ({ banners = [] }) => {
  const shouldAutoplay = banners.length > 1
  const isMobile = useMediaLess(600)
  return (
    <section>
      <CwsCarousel autoplay={shouldAutoplay}>
        {banners.map((banner, idx) => {
          if (banner.clickUrl)
            return (
              <article key={banner.image} className="hover:opacity-90">
                <Link href={banner.clickUrl} passHref>
                  <section style={{ width: '100%', aspectRatio: '1288 / 460', position: 'relative' }}>
                    <CldImage
                      layout="fill"
                      src={banner.image}
                      namedTransformations={isMobile ? ['m-banner'] : ['banner']}
                      alt={`image-banner-url-${idx}`}
                    />
                  </section>
                </Link>
              </article>
            )
          return (
            <article key={banner.image} className="hover:opacity-90">
              <section style={{ width: '100%', aspectRatio: '1288 / 460', position: 'relative' }}>
                <CldImage
                  layout="fill"
                  src={banner.image}
                  namedTransformations={isMobile ? ['m-banner'] : ['banner']}
                  alt={`image-banner-url-${idx}`}
                />
              </section>
            </article>
          )
        })}
      </CwsCarousel>
    </section>
  )
}
